import { HeaderTitle } from "./HeaderTitle";
import { useEffect, useState, useRef } from "react";
import PopOutModal from "./PopOutModal";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "../styles/IntelligentCrossValidation.css";
import Api_Call from "../../ApiCall";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ShortcutIcon from "@mui/icons-material/Shortcut";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import axios from "axios";
import Spinner from "./Spinner";
import { AIModels } from "./HalfBoxClinical";

import PopOutModalIntelligentQuery from "./PopOutModalIntelligentQuery";
let heightDataContainer = 0;

// const htmlToRenderLLM=[];

function IntelligentCrossValidation(props) {
  const [showOptions, setShowOptions] = useState(false);
  const [idNum, setIdNum] = useState(0);
  const [isSearchLLmPressed, setIsSearchLLmPressed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [elementHeight, setElementHeight] = useState(0);

  const [questionLLM, setQuestionLLM] = useState("");
  const [queryObjects, setQueryObjects] = useState([]);
  const [answerLLM, setAnswerLLM] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [htmlToRenderLLM, setHtmlToRenderLLM] = useState([]);

  const inputRef = useRef(null);

  const myElementRef = useRef(null);

  const handleQuery = () => {
    setIsOpen(true);
  };
  const handleToggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const handleOptionClick = (option) => {
    // Handle the selected option
    console.log("Selected Option:", option);
    // You can perform any action with the selected option here

    // Close the options after selection
    // setShowOptions(false);
  };
  const options = ["Query"];

  const [requestObject, setRequestObject] = useState({});

  const handleSearchLLM = async () => {
    inputRef.current.focus();
    setIsSearchLLmPressed(true);
    setIsExpanded(true);

    const questionPre =
      inputRef.current.value[inputRef.current.value.length - 1] !== "?"
        ? inputRef.current.value + "?"
        : inputRef.current.value;
    console.log();
    const question = encodeURIComponent(questionPre);
    const task_ID = sessionStorage.getItem("ActiveTaskID");

    const currentId = idNum;
    setQueryObjects((prev) => [
      ...prev,
      {
        id: currentId,
        question: questionPre,
        answer: null,
        error: null,
      },
    ]);
    // setIsLoading(true);
    const url = `https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_vacreui_getllmdata?env=QA&task_ID=${task_ID}&question=${question}`;

    const reqObj = { question, task_ID, questionPre, url };
    setRequestObject(reqObj);

    const fetchLLMData = async ({ question, task_ID, questionPre, url }) => {
      if (!inputRef.current) return;
      const url_model =
        props.model == AIModels.GEMINI
          ? `GENAI/GEMINI?task_ID=${task_ID}&purpose=initiatechat&filename=${props.filepath}&question=${question}`
          : `GENAI/BEDROCK?task_ID=${task_ID}&purpose=initiatechat&filename=${props.filepath}&model=${props.model}&prompt=${question}`;

      try {
        setIsLoading(true);
        const api = new Api_Call();

        const data = await api.getData(url_model);
        if (data.statusCode != 200) {
          throw new Error("Some Error Occured...");
        }
        console.log(data.body);
        const dataForAns =
          props.model == AIModels.GEMINI ? data.body : data.body.plaintext;

        const objForArray = {
          question: questionPre,
          answer: dataForAns,
        };

        setQueryObjects((prev) => {
          const existingIndex = prev.findIndex((obj) => obj.id === currentId);

          if (existingIndex !== -1) {
            return prev.map((obj, index) => {
              if (index === existingIndex) {
                return {
                  ...obj,
                  answer: dataForAns,
                };
              }

              return obj;
            });
          } else {
            return [
              ...prev,
              {
                id: currentId,
                question: questionPre,
                answer: "Not Found",
              },
            ];
          }
        });
        console.log(objForArray);
      } catch (error) {
        console.error("Error Happened");

        setQueryObjects((prev) => {
          const existingIndex = prev.findIndex((obj) => obj.id === currentId);

          if (existingIndex !== -1) {
            return prev.map((obj, index) => {
              if (index === existingIndex) {
                return {
                  ...obj,
                  answer: error.message,
                };
              }

              return obj;
            });
          } else {
            return [
              ...prev,
              {
                id: currentId,
                question: questionPre,
                answer: error.message,
              },
            ];
          }
        });
      } finally {
        setIsLoading(false);
        setIdNum((prev) => prev + 1);
      }
    };
    fetchLLMData(reqObj);

    inputRef.current.value = "";
  };

  console.log(queryObjects);

  useEffect(
    () => {
      console.log("Inside UseEffect question", questionLLM);
      console.log("Inside UseEffect Answer", answerLLM);

      console.log("LOAding-----", isLoading);
      // if (!isLoading && answerLLM && questionLLM)
      queryObjects.forEach((item) => {});
      if (!isLoading) {
        console.log("dataPushed");

        // setHtmlToRenderLLM((prevValue) => [
        //   ...prevValue,

        //   <div id="data--container" style={{ margin: "30px", marginTop: "0" }}>
        //     <div style={{ marginBottom: "30px" }}>
        //       <div style={{ display: "flex" }}>
        //         <div
        //           style={{
        //             position: "absolute",
        //             backgroundColor: "red",
        //             borderRadius: "50%",
        //             width: "5px",
        //             height: "5px",
        //             transform: "translate(-550%,100%)",
        //           }}
        //         ></div>
        //         <p style={{ fontWeight: "500", fontSize: "15px" }}>
        //           {sessionStorage.getItem("Name")}: <span></span>
        //           {questionLLM}
        //         </p>
        //       </div>
        //       <div style={{ margin: "15px" }}>
        //         <span style={{ fontWeight: "bold", fontSize: "13px" }}>
        //           {props.model} :{" "}
        //         </span>
        //         <div dangerouslySetInnerHTML={{ __html: answerLLM }}></div>
        //       </div>
        //     </div>
        //   </div>,
        // ]);
      }

      // setIsExpanded(false);
    },
    [isLoading, answerLLM, questionLLM, isSearchLLmPressed]
    // [isLoading,requestObject.url]
  );

  console.log("Question---------->", questionLLM);
  console.log("Answer--------->", answerLLM);
  const dotStyle = {
    // color: 'red',
    // // transform: 'scale(2)',
    // fontSize:'3rem',
    // position: 'absolute',
    // left:'0%',
    // top:'0%'
    // display:'flex',

    position: "absolute",
    // top: '50%',
    // left: '50%',
    // transform: 'translateX(-29%)',
    backgroundColor: "red",
    borderRadius: "50%",
    width: "10px",
    height: "10px",
  };

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
    // Continue with the rest of your code
  };

  const containerStyle = {
    position: "relative",
    marginBottom: isExpanded ? "50px" : "0",
  };

  const lineStyle = {
    content: '""',
    position: "absolute",
    height: isExpanded ? `${heightDataContainer + 50}px` : "0", // Expand or collapse the line based on the expansion state
    width: ".5px", // Adjust the line thickness as needed
    background: "red",
    left: "0%",
    top: "10%",
    transform: "translateX(4.25px)",
    transition: "height 0.3s ease", // Add a smooth transition effect
  };

  useEffect(() => {
    const element = myElementRef.current;
    console.log("================>>>>>>>>", element);
    if (element) {
      heightDataContainer = element.offsetHeight;
      setElementHeight(heightDataContainer);
      console.log("Element height:", heightDataContainer);
    }
  }, [
    myElementRef.current,
    isExpanded,
    isOpen,
    isSearchLLmPressed,
    heightDataContainer,
    htmlToRenderLLM,
  ]);

  console.log(htmlToRenderLLM);

  return (
    <>
      <div className="intelligentQ-clinical">
        <div
          style={{ background: "white", borderRadius: "10px", padding: "5px" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <HeaderTitle
              divStyle="header-div--sub"
              headerStyle="header--sub"
              headerSize="header--small"
              headerColor="header--color"
              divAlign="header--left"
              textContent="Digital UM Copilot"
            ></HeaderTitle>
            <div onClick={handleQuery}>
              <span
                style={{
                  fontSize: "2rem",
                  fontWeight: "bold",
                  color: "#fb4e0b",
                  cursor: "pointer",
                }}
              >
                {"\u002B"}
              </span>
            </div>
          </div>
        </div>
      </div>

      <PopOutModal
        isOpen={isOpen}
        isSmall={true}
        widthTo="70%"
        onClose={() => {
          console.log("XXXX clicked");
          setIsOpen(false);
        }}
        content={
          <div
            style={{
              padding: "10px",
              background: "rgba(0,0,0,0.1)",
              position: "relative",
            }}
          >
            <div
              style={{
                border: "1px dotted #fb4e0b",
                padding: "1rem",
                margin: "10px",
                background: "white",
                boxShadow: "5px 5px 2px rgba(0,0,0,0.2)",
              }}
            >
              <HeaderTitle
                divStyle="header-div--sub"
                headerStyle="header--sub"
                headerSize="header--medium"
                //   divAlign="header--left"
                textContent="Digital UM Copilot"
              ></HeaderTitle>
            </div>
            {!props.model && (
              <div className="intelligent-query-contentBox intelligent-query-contentBox-center">
                Please Select an AI Model
              </div>
            )}

            {props.model && (
              <div className="intelligent-query-contentBox intelligent-query-contentBox-large">
                <div style={{ ...containerStyle }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={dotStyle}>
                      {/* <span style={lineStyle}></span> */}
                    </div>

                    <div
                      style={{
                        margin: "25px",
                        fontSize: "1.5rem",
                        fontWeight: "700",
                      }}
                    >
                      Query
                    </div>

                    <button
                      style={{
                        color: "#fb4e0b",
                        background: "white",
                        border: "0px",
                        fontSize: "1.5rem",
                        cursor: "pointer",
                      }}
                      onClick={toggleExpansion}
                    >
                      {!isExpanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                    </button>
                  </div>
                  {/* <span style={lineStyle}></span> */}

                  {isExpanded && (
                    <>
                      <div
                        ref={myElementRef}
                        style={{ opacity: isExpanded ? 1 : 0 }}
                      >
                        {/* {htmlToRenderLLM.map((item, index) => {
                          // Uncomment the return statement and JSX
                          return (
                            <div
                              key={index}
                              id="html--render"
                              style={{ background: "white" }}
                            >
                            // Add your JSX code here 
                              {item}
                            </div>
                          );
                        })} */}

                        {queryObjects.map((item, index) => {
                          return (
                            <div
                              id="data--container"
                              className="query-summary"
                              // style={{ margin: "30px", marginTop: "0" }}
                            >
                              <div style={{ marginBottom: "30px" }}>
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{
                                      position: "absolute",
                                      backgroundColor: "red",
                                      borderRadius: "50%",
                                      width: "5px",
                                      height: "5px",
                                      transform: "translate(-550%,100%)",
                                    }}
                                  ></div>
                                  <p
                                    style={{
                                      fontWeight: "500",
                                    }}
                                  >
                                    Question :<span></span>
                                    {item.question}
                                  </p>
                                </div>
                                {(!isLoading || item.answer !== null) && (
                                  <div style={{ margin: "15px" }}>
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Answer :{" "}
                                    </span>

                                    <div>{item.answer}</div>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
                <div style={{ display: "flex", position: "relative" }}>
                  <input
                    className="input-query"
                    placeholder="Write your Query here?"
                    ref={inputRef}
                    onKeyDown={(e) => {
                      if (e.key == "Enter") {
                        handleSearchLLM();
                      }
                    }}
                  />
                  {isLoading ? (
                    <Spinner
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        fontSize: "22px",
                        top: "21%",
                        right: "1%",
                      }}
                    />
                  ) : (
                    <FindInPageIcon
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        fontSize: "22px",
                        top: "21%",
                        right: "1%",
                      }}
                      onClick={handleSearchLLM}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        }
      ></PopOutModal>
    </>
  );
}

export default IntelligentCrossValidation;
